import EthereumService from '@/services/ethereum'

export default class Service extends EthereumService {
  constructor (options) {
    super()
    this.store = options.store
    this.kulapApi = options.kulapApi
  }

  async getUserProfile () {
    const { data } = await this.kulapApi.getUserProfile()
    this.store.dispatch('setUser', data)
    return data
  }

  async submitKnowledgeTest (formData) {
    const { data } = await this.kulapApi.patchSubmitKnowledgeTest(formData)
    return data
  }
}



// WEBPACK FOOTER //
// ./src/pages/KnowledgeTest/service.js